<div
  [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
  class="mode-content  {{ storageService.isSidebarClose ? '' : 'responsive-margin' }} {{
    storageService?.isSidebarClose && !storageService.detectMob() ? 'margin-close-sidebar' : ''
  }}"
  *ngIf="!router.url.includes('administration') && !router.url.includes('sign-up')"
>
  <ng-container
    *ngIf="!router.url.includes('login') && !router.url.includes('sign-up') && !router.url.includes('administration')"
  >
    <div class="cursor-pointer change-mode">
      <span class="ml-1 switch-mode-top-label quicksand-bold-label" *ngIf="storageService?.isSidebarClose">
        Video Tutorial
      </span>
      <nb-toggle
        [labelPosition]="!storageService.detectMob() ? 'start' : 'end'"
        (checkedChange)="showTotorial($event)"
        [(ngModel)]="isShowTutorial"
        class="side-bar-toogle"
      >
        <span
          class="switch-mode-label quicksand-bold-label"
          *ngIf="!storageService?.isSidebarClose"
          [ngClass]="{
            'ml-2': !storageService.detectMob()
          }"
        >
          Video Tutorial
        </span></nb-toggle
      >
    </div>
  </ng-container>

  <div class="cursor-pointer change-mode" *ngIf="!router.url.includes('login')">
    <span class="ml-1 mr-2 switch-mode-top-label quicksand-bold-label" *ngIf="storageService?.isSidebarClose">
      Dark Theme
    </span>
    <nb-toggle
      [labelPosition]="!storageService.detectMob() ? 'start' : 'end'"
      (checkedChange)="toggleTheme($event)"
      [(ngModel)]="isLightMode"
      class="side-bar-toogle"
    >
      <span
        class="mr-2 switch-mode-label quicksand-bold-label"
        *ngIf="!storageService?.isSidebarClose"
        [ngClass]="{
          'ml-2': !storageService.detectMob()
        }"
      >
        Dark Theme
      </span></nb-toggle
    >
  </div>
</div>
